import { WarnDotIcons, WarnLevelIcons, WarnTypeColor } from '@/layout/screen/bottom/warn';
import { Table } from 'antd';
import { useEffect, useState, useRef } from 'react';


interface IProps {
    dataSource: any[]
}

export default function WarnTable(props: IProps) {


    return (
        <Table
            rowKey="id" // 数据唯一标识
            pagination={false} // 禁用分页
            dataSource={props.dataSource} // 数据源
            bordered={false} // 无边框
            className='expense-table' // 自定义表格样式
            onRow={(row, index) => {
                return {}
            }}
            sticky // 固定表头
        > 
            <Table.Column dataIndex="id" title={(<div className='head-cell head-cell-first'></div>)} key="name" width={20} render={(value, row) => (
                <div className='read-only-cell read-only-cell-first'>
                    <div style={{ marginTop: 3 }}>{WarnDotIcons[row?.level]}</div>
                </div>
            )} />
            <Table.Column dataIndex="id" title={(<div className='head-cell'>名称</div>)} render={(value, row) => (
                <div className='read-only-cell'>
                    {row?.key_name}
                </div>
            )} />
            <Table.Column dataIndex="level" title={(<div className='head-cell'>指标</div>)} key="level" render={(value, row) => (
                <div className='read-only-cell'>
                    {`${row?.chinese_name}${row?.name}`}
                </div>
            )} />
            <Table.Column dataIndex="level" title={(<div className='head-cell'>当前数值</div>)} key="level" render={(value, row) => (
                <div className='read-only-cell'>
                    {`${row?.current_value?.toFixed(4)}${row?.unit_type}`}
                </div>
            )} />
            <Table.Column dataIndex="level" title={(<div className='head-cell head-cell-end'>等级</div>)} key="level" width={60} render={(value, row) => (
                <div className='read-only-cell read-only-cell-end'>
                    <div style={{ marginTop: 3 }}>{WarnLevelIcons[value]}</div>
                </div>
            )} />
        </Table>
    )
}